<template>
  <v-tooltip
    :top="top"
    :bottom="bottom"
    :left="left"
    :right="right"
    :disabled="!tooltip && !$slots.tooltip"
  >
    <template #activator="{ on }">
      <slot name="activator">
        <v-btn
          :color="color"
          :to="to"
          :href="href"
          :target="target"
          :icon="!!icon"
          :depressed="depressed"
          :disabled="disabled"
          :rounded="rounded"
          :small="small"
          :class="classButton"
          :style="styleButton"
          :tile="tile"
          :loading="loading || isLoading"
          :x-small="xSmall"
          :download="download"
          v-on="on"
          @click="onClick"
        >
          <slot name="button-inner">
            <v-icon
              v-if="icon"
              :small="iconSize ? void 0 : small"
              :size="iconSize"
              v-text="icon"
            />

            <span v-if="text">
              {{ text }}
            </span>
          </slot>
        </v-btn>
      </slot>
    </template>

    <slot name="tooltip">
      <span>{{ tooltip }}</span>
    </slot>
  </v-tooltip>
</template>

<script>


export default {
  name: 'BTooltipButton',
  inheritAttrs: false,
  props: {
    disabled: Boolean,
    icon: String,
    iconSize: [String, Number],
    text: String,
    tooltip: String,
    top: Boolean,
    bottom: Boolean,
    right: Boolean,
    left: Boolean,

    // button
    color: String,
    depressed: Boolean,
    to: [String, Object],
    href: String,
    target: String,
    rounded: Boolean,
    small: Boolean,
    tile: Boolean,
    classButton: null,
    styleButton: null,
    loading: Boolean,
    xSmall: Boolean,
    download: String,
  },
  data: () => ({
    isLoading: false,
  }),
  methods: {
    toggleLoading() {
      this.isLoading = !this.isLoading
      return this.toggleLoading
    },
    onClick(e) {
      e.toggleLoading = this.toggleLoading
      this.$emit('click', e)
    },
  },
}
</script>
